module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_int_r1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_ack_r1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc11"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c001_r1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("c. 2500 BCE")])]), _vm._v(" Sumerian Abacus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c002_r1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("c. 700 BCE")])]), _vm._v(" Scytale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c003_r1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("c. 150 BCE")])]), _vm._v(" Antikythera Mechanism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c004_r1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("c. 60")])]), _vm._v(" Programmable Robot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c005_r1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("c. 850")])]), _vm._v(" "), _c('i', [_vm._v("On Deciphering Cryptographic Messages")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c006_r1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("c. 1470")])]), _vm._v(" Cipher Disk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c007_r1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1613")])]), _vm._v(" First Recorded Use of the Word "), _c('i', [_vm._v("Computer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c008_r1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1621")])]), _vm._v(" Slide Rule")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c009_r1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1703")])]), _vm._v(" Binary Arithmetic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c010_r1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1758")])]), _vm._v(" Human Computers Predict Halley’s Comet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c011_r1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1770")])]), _vm._v(" The “Mechanical Turk”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c012_r1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1792")])]), _vm._v(" Optical Telegraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c013_r1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1801")])]), _vm._v(" The Jacquard Loom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c014_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1822")])]), _vm._v(" The Difference Engine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c015_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1836")])]), _vm._v(" Electrical Telegraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c016_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1843")])]), _vm._v(" Ada Lovelace Writes a Computer Program")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c017_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1843")])]), _vm._v(" Fax Machine Patented")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c018_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1843")])]), _vm._v(" Edgar Allan Poe’s “The Gold-Bug”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c019_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1851")])]), _vm._v(" Thomas Arithmometer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c020_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1854")])]), _vm._v(" Boolean Algebra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c021_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1864")])]), _vm._v(" First Electromagnetic Spam Message")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c022_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1874")])]), _vm._v(" Baudot Code")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c023_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1874")])]), _vm._v(" Semiconductor Diode")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c024_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1890")])]), _vm._v(" Tabulating the US Census")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c025_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1891")])]), _vm._v(" Strowger Step-by-Step Switch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c026_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1914")])]), _vm._v(" Floating-Point Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c027_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1917")])]), _vm._v(" Vernam Cipher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c028_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1920")])]), _vm._v(" "), _c('i', [_vm._v("Rossum’s Universal Robots")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c029_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1927")])]), _vm._v(" "), _c('i', [_vm._v("Metropolis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c030_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1927")])]), _vm._v(" First LED")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c031_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1928")])]), _vm._v(" Electronic Speech Synthesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c032_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1931")])]), _vm._v(" Differential Analyzer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c033_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1936")])]), _vm._v(" Church-Turing Thesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c034_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1941")])]), _vm._v(" Z3 Computer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c035_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1942")])]), _vm._v(" Atanasoff-Berry Computer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c036_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1942")])]), _vm._v(" Isaac Asimov’s Three Laws of Robotics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c037_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1943")])]), _vm._v(" ENIAC")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c038_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1943")])]), _vm._v(" Colossus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c039_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1944")])]), _vm._v(" Delay Line Memory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c040_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1944")])]), _vm._v(" Binary-Coded Decimal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c041_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1945")])]), _vm._v(" “As We May Think”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c042_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1945")])]), _vm._v(" EDVAC "), _c('i', [_vm._v("First Draft")]), _vm._v(" Report")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c043_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1946")])]), _vm._v(" Trackball")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c044_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1946")])]), _vm._v(" Williams Tube")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c045_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1947")])]), _vm._v(" Actual Bug Found")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c046_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1947")])]), _vm._v(" Silicon Transistor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c047_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1948")])]), _vm._v(" The Bit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c048_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1948")])]), _vm._v(" Curta Calculator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c049_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1948")])]), _vm._v(" Manchester SSEM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c050_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1949")])]), _vm._v(" Whirlwind")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c051_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1950")])]), _vm._v(" Error-Correcting Codes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c052_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1951")])]), _vm._v(" The Turing Test")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c053_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1951")])]), _vm._v(" Magnetic Tape Used for Computers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c054_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1951")])]), _vm._v(" Core Memory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c055_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1951")])]), _vm._v(" Microprogramming")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c056_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1952")])]), _vm._v(" Computer Speech Recognition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c057_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1953")])]), _vm._v(" First Transistorized Computer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c058_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1955")])]), _vm._v(" "), _c('i', [_vm._v("Artificial Intelligence")]), _vm._v(" Coined")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c059_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1955")])]), _vm._v(" Computer Proves Mathematical Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c060_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1956")])]), _vm._v(" First Disk Storage Unit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c061_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1956")])]), _vm._v(" The Byte")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c062_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1956")])]), _vm._v(" Robby the Robot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c063_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1957")])]), _vm._v(" FORTRAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c064_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1957")])]), _vm._v(" First Digital Image")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c065_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1958")])]), _vm._v(" The Bell 101 Modem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c066_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1958")])]), _vm._v(" SAGE Computer Operational")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c067_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1959")])]), _vm._v(" IBM 1401")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c068_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1959")])]), _vm._v(" PDP-1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c069_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1959")])]), _vm._v(" Quicksort")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c070_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1959")])]), _vm._v(" Airline Reservation System")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c071_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1960")])]), _vm._v(" COBOL Computer Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c072_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1960")])]), _vm._v(" Recommended Standard 232")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c073_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1961")])]), _vm._v(" ANITA Electronic Calculator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c074_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1961")])]), _vm._v(" Unimate: First Mass-Produced Robot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c075_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1961")])]), _vm._v(" Time-Sharing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c076_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1962")])]), _vm._v(" "), _c('i', [_vm._v("Spacewar!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c077_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1962")])]), _vm._v(" Virtual Memory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c078_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1962")])]), _vm._v(" Digital Long Distance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c079_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1963")])]), _vm._v(" Sketchpad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c080_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1963")])]), _vm._v(" ASCII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c081_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1964")])]), _vm._v(" RAND Tablet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c082_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1964")])]), _vm._v(" Teletype Model 33 ASR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c083_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1964")])]), _vm._v(" IBM System/360")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c084_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1964")])]), _vm._v(" BASIC Computer Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c085_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1965")])]), _vm._v(" First Liquid-Crystal Display")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c086_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1965")])]), _vm._v(" Fiber Optics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c087_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1965")])]), _vm._v(" DENDRAL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c088_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1965")])]), _vm._v(" ELIZA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c089_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1965")])]), _vm._v(" Touchscreen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c090_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1966")])]), _vm._v(" "), _c('i', [_vm._v("Star Trek")]), _vm._v(" Premieres")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c091_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1966")])]), _vm._v(" Dynamic RAM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c092_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1967")])]), _vm._v(" Object-Oriented Programming")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c093_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1967")])]), _vm._v(" First Cash Machine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c094_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1967")])]), _vm._v(" Head-Mounted Display")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c095_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1967")])]), _vm._v(" Programming for Children")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c096_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1967")])]), _vm._v(" The Mouse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c097_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1968")])]), _vm._v(" Carterfone Decision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c098_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1968")])]), _vm._v(" Software Engineering")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c099_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1968")])]), _vm._v(" HAL 9000 Computer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c100_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1968")])]), _vm._v(" First Spacecraft Guided by Computer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c101_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1968")])]), _vm._v(" "), _c('i', [_vm._v("Cyberspace")]), _vm._v(" Coined—and Re-Coined")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c102_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1968")])]), _vm._v(" Mother of All Demos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c103_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1968")])]), _vm._v(" Dot Matrix Printer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c104_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1968")])]), _vm._v(" Interface Message Processor (IMP)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c105_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1969")])]), _vm._v(" ARPANET/Internet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c106_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1969")])]), _vm._v(" Digital Imaging")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c107_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1969")])]), _vm._v(" "), _c('i', [_vm._v("Network Working Group Request for Comments: 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c108_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1969")])]), _vm._v(" Utility Computing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c109_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1969")])]), _vm._v(" "), _c('i', [_vm._v("Perceptrons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c110_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1969")])]), _vm._v(" UNIX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c111_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1970")])]), _vm._v(" Fair Credit Reporting Act")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c112_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1970")])]), _vm._v(" Relational Database")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c113_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1970")])]), _vm._v(" Floppy Disk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c114_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1971")])]), _vm._v(" Laser Printer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c115_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1971")])]), _vm._v(" NP-Completeness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c116_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1971")])]), _vm._v(" @Mail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c117_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1971")])]), _vm._v(" First Microprocessor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c118_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1971")])]), _vm._v(" First Wireless Network")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c119_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1972")])]), _vm._v(" C Programming Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c120_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1972")])]), _vm._v(" Cray Research")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c121_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1972")])]), _vm._v(" "), _c('i', [_vm._v("Game of Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c122_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1972")])]), _vm._v(" HP-35 Calculator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c123_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1972")])]), _vm._v(" "), _c('i', [_vm._v("Pong")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c124_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1973")])]), _vm._v(" First Cell Phone Call")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c125_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1973")])]), _vm._v(" Xerox Alto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c126_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1974")])]), _vm._v(" Data Encryption Standard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c127_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1974")])]), _vm._v(" First Personal Computer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c128_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1975")])]), _vm._v(" "), _c('i', [_vm._v("Adventure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c129_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1975")])]), _vm._v(" "), _c('i', [_vm._v("The Shockwave Rider")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c130_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1975")])]), _vm._v(" AI Medical Diagnosis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c131_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1975")])]), _vm._v(" "), _c('i', [_vm._v("BYTE")]), _vm._v(" Magazine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c132_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1975")])]), _vm._v(" Homebrew Computer Club")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c133_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1975")])]), _vm._v(" "), _c('i', [_vm._v("The Mythical Man-Month")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c134_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1976")])]), _vm._v(" Public Key Cryptography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c135_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1976")])]), _vm._v(" Tandem NonStop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c136_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1976")])]), _vm._v(" "), _c('i', [_vm._v("Dr. Dobb’s Journal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c137_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1977")])]), _vm._v(" RSA Encryption")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c138_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1977")])]), _vm._v(" Apple II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c139_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1978")])]), _vm._v(" First Internet Spam Message")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c140_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1978")])]), _vm._v(" Minitel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c141_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1979")])]), _vm._v(" Secret Sharing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c142_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1979")])]), _vm._v(" VisiCalc")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c143_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1980")])]), _vm._v(" Sinclair ZX80")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c144_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1980")])]), _vm._v(" Flash Memory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c145_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1980")])]), _vm._v(" RISC")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c146_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1980")])]), _vm._v(" Commercially Available Ethernet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c147_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1980")])]), _vm._v(" Usenet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c148_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1981")])]), _vm._v(" IBM PC")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c149_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1981")])]), _vm._v(" Simple Mail Transfer Protocol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c150_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1981")])]), _vm._v(" Japan’s Fifth Generation Computer Systems")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c151_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1982")])]), _vm._v(" AutoCAD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c152_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1982")])]), _vm._v(" First Commercial UNIX Workstation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c153_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1982")])]), _vm._v(" PostScript")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c154_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1982")])]), _vm._v(" Microsoft and the Clones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c155_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1982")])]), _vm._v(" First CGI Sequence in Feature Film")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c156_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1982")])]), _vm._v(" "), _c('i', [_vm._v("National Geographic")]), _vm._v(" Moves the Pyramids")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c157_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1982")])]), _vm._v(" Secure Multi-Party Computation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c158_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1982")])]), _vm._v(" "), _c('i', [_vm._v("TRON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c159_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1982")])]), _vm._v(" Home Computer Named Machine of the Year")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c160_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1983")])]), _vm._v(" The Qubit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c161_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1983")])]), _vm._v(" "), _c('i', [_vm._v("WarGames")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c162_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1983")])]), _vm._v(" 3-D Printing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c163_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1983")])]), _vm._v(" Computerization of the Local Telephone Network")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c164_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1983")])]), _vm._v(" First Laptop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c165_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1983")])]), _vm._v(" MIDI Computer Music Interface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c166_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1983")])]), _vm._v(" Microsoft Word")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c167_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1983")])]), _vm._v(" Nintendo Entertainment System")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c168_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1983")])]), _vm._v(" Domain Name System")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c169_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1983")])]), _vm._v(" IPv4 Flag Day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c170_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1984")])]), _vm._v(" Text-to-Speech")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c171_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1984")])]), _vm._v(" Macintosh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c172_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1984")])]), _vm._v(" VPL Research, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c173_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1984")])]), _vm._v(" Quantum Cryptography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c174_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1984")])]), _vm._v(" Telebit Modems Break 9600 bps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c175_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1984")])]), _vm._v(" Verilog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c176_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1985")])]), _vm._v(" Connection Machine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c177_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1985")])]), _vm._v(" First Computer-Generated TV Host")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c178_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1985")])]), _vm._v(" Zero-Knowledge Proofs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c179_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1985")])]), _vm._v(" FCC Approves Unlicensed Spread Spectrum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c180_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1985")])]), _vm._v(" NSFNET")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c181_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1985")])]), _vm._v(" Desktop Publishing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c182_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1985")])]), _vm._v(" Field-Programmable Gate Array")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c183_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1985")])]), _vm._v(" GNU Manifesto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c184_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1985")])]), _vm._v(" AFIS Stops a Serial Killer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c185_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1986")])]), _vm._v(" Software Bug Fatalities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c186_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1986")])]), _vm._v(" Pixar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c187_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1987")])]), _vm._v(" Digital Video Editing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c188_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1987")])]), _vm._v(" GIF")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c189_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1988")])]), _vm._v(" MPEG")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c190_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1988")])]), _vm._v(" CD-ROM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c191_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1988")])]), _vm._v(" Morris Worm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c192_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1989")])]), _vm._v(" World Wide Web")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c193_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1989")])]), _vm._v(" "), _c('i', [_vm._v("SimCity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c194_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1989")])]), _vm._v(" ISP Provides Internet Access to the Public")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c195_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1990")])]), _vm._v(" GPS Is Operational")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c196_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1990")])]), _vm._v(" Digital Money")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c197_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1991")])]), _vm._v(" Pretty Good Privacy (PGP)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c198_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1991")])]), _vm._v(" "), _c('i', [_vm._v("Computers at Risk")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c199_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1991")])]), _vm._v(" Linux Kernel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c200_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1992")])]), _vm._v(" Boston Dynamics Founded")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c201_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1992")])]), _vm._v(" JPEG")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c202_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1992")])]), _vm._v(" First Mass-Market Web Browser")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c203_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1992")])]), _vm._v(" Unicode")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c204_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1993")])]), _vm._v(" Apple Newton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c205_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1994")])]), _vm._v(" First Banner Ad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c206_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1994")])]), _vm._v(" RSA-129 Cracked")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c207_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1995")])]), _vm._v(" DVD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c208_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1995")])]), _vm._v(" E-Commerce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c209_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1995")])]), _vm._v(" AltaVista Web Search Engine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c210_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1995")])]), _vm._v(" Gartner Hype Cycle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c211_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1996")])]), _vm._v(" Universal Serial Bus (USB)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c212_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1997")])]), _vm._v(" Computer Is World Chess Champion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c213_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1997")])]), _vm._v(" PalmPilot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c214_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1997")])]), _vm._v(" E Ink")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c215_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1998")])]), _vm._v(" Diamond Rio MP3 Player")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c216_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1998")])]), _vm._v(" Google")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c217_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1999")])]), _vm._v(" Collaborative Software Development")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c218_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1999")])]), _vm._v(" "), _c('i', [_vm._v("Blog")]), _vm._v(" Is Coined")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c219_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("1999")])]), _vm._v(" Napster")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c220_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2000")])]), _vm._v(" USB Flash Drive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c221_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2001")])]), _vm._v(" Wikipedia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c222_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2001")])]), _vm._v(" iTunes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c223_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2001")])]), _vm._v(" Advanced Encryption Standard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c224_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2001")])]), _vm._v(" Quantum Computer Factors “15”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c225_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2002")])]), _vm._v(" Home-Cleaning Robot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c226_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2003")])]), _vm._v(" CAPTCHA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c227_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2004")])]), _vm._v(" Product Tracking")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c228_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2004")])]), _vm._v(" Facebook")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c229_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2004")])]), _vm._v(" First International Meeting on Synthetic Biology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c230_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2005")])]), _vm._v(" Video Game Enables Research into Real-World Pandemics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c231_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2006")])]), _vm._v(" Hadoop Makes Big Data Possible")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c232_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2006")])]), _vm._v(" Differential Privacy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c233_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2007")])]), _vm._v(" iPhone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c234_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2008")])]), _vm._v(" Bitcoin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c235_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2010")])]), _vm._v(" Air Force Builds Supercomputer with Gaming Consoles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c236_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2010")])]), _vm._v(" Cyber Weapons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c237_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2011")])]), _vm._v(" Smart Homes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c238_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2011")])]), _vm._v(" Watson Wins "), _c('i', [_vm._v("Jeopardy!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c239_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2011")])]), _vm._v(" World IPv6 Day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c240_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2011")])]), _vm._v(" Social Media Enables the Arab Spring")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c241_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2012")])]), _vm._v(" DNA Data Storage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c242_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2013")])]), _vm._v(" Algorithm Influences Prison Sentence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c243_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2013")])]), _vm._v(" Subscription Software")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c244_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2014")])]), _vm._v(" Data Breaches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c245_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2014")])]), _vm._v(" Over-the-Air Vehicle Software Updates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c246_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2015")])]), _vm._v(" Google Releases TensorFlow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c247_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2016")])]), _vm._v(" Augmented Reality Goes Mainstream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c248_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("2016")])]), _vm._v(" Computer Beats Master at Go")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c249_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("~2050")])]), _vm._v(" Artificial General Intelligence (AGI)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c250_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("~9999")])]), _vm._v(" The Limits of Computation?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc11"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_nts_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes and Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_crd_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Credits")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62d452c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454926221_epub_toc_r1.vue
// module id = 66
// module chunks = 0